<template>
  <div id="content">
    <Search />
    <div class="container">
      <div class="breadcrumb-wrap">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
      </div>
      <div class="position">
        <div class="bg-white p-20">
          <div class="offer-form-main">
            <form @submit.prevent="createOffer" ref="form">
              <div class="offer-form-body">
                <div
                  class="form-group"
                  :class="{
                    invalid: $v.offerTitle.$dirty && !$v.offerTitle.required
                  }"
                >
                  <div class="row">
                    <div class="col-sm-3">
                      <label for="title">
                        {{ $t("Наименование предложения") }}
                        <span class="asterix">*</span>
                        <fieldInfo :title="$t('Введите название предложения. Оно должно кратко отражать суть вашей идеи.')" />
                      </label>
                    </div>
                    <div class="col-sm-9">
                      <v-text-field
                        id="title"
                        v-model="offerTitle"
                        :aria-label="$t('Наименование предложения')"
                        :aria-invalid="$v.offerTitle.$dirty && !$v.offerTitle.required ? 'true' : 'false'"
                        outlined
                        rounded
                        dense
                        name="offer[title]"
                      ></v-text-field>
                    </div>
                  </div>
                </div>
                <div
                  class="form-group"
                  :class="{
                    invalid: $v.offerType.$dirty && !$v.offerType.required
                  }"
                >
                  <div class="row">
                    <div class="col-sm-3">
                      <label for="type">
                        {{ $t("Тип предложения") }}
                        <span class="asterix">*</span>
                        <fieldInfo :title="$t('Выберите тип предложения из списка.')" />
                      </label>
                    </div>
                    <div class="col-sm-9">
                      <v-select
                        id="type"
                        item-value="id"
                        item-text="transName"
                        v-model="offerType"
                        :items="refOfferType"
                        :aria-label="$t('Тип предложения')"
                        :aria-invalid="$v.offerType.$dirty && !$v.offerType.required ? 'true' : 'false'"
                        input="transName"
                        outlined
                        rounded
                        dense
                      ></v-select>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="row">
                    <div class="col-sm-3">
                      <label for="developer">
                        {{ $t("Государственные органы, которые могут помочь реализовать Ваше предложение") }}
                        <fieldInfo :title="$t('Выберите государственные органы, которые могут помочь в реализации вашего предложения.')" />
                      </label>
                    </div>
                    <div class="col-sm-9">
                      <v-autocomplete
                        id="developer"
                        item-value="id"
                        item-text="transName"
                        v-model="offerDeveloper"
                        :items="refDeveloper"
                        :aria-label="$t('Государственные органы, которые могут помочь реализовать Ваше предложение')"
                        input="transName"
                        outlined
                        rounded
                        dense
                        multiple
                      ></v-autocomplete>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="row">
                    <div class="col-sm-3">
                      <label for="category">
                        {{ $t("Категории") }}
                        <fieldInfo :title="$t('Выберите категорию, к которой относится ваше предложение.')" />
                      </label>
                    </div>
                    <div class="col-sm-9">
                      <v-select
                        id="category"
                        item-value="id"
                        item-text="transName"
                        v-model="offerCategory"
                        :items="refCategory"
                        :aria-label="$t('Категории')"
                        input="transName"
                        outlined
                        rounded
                        dense
                      ></v-select>
                    </div>
                  </div>
                </div>
                <div
                  class="form-group"
                  :class="{
                    invalid: $v.offerContent.$dirty && !$v.offerContent.required
                  }"
                >
                  <label>
                    {{ $t("Текст предложения") }}
                    <span class="asterix">*</span>
                    <fieldInfo :title="$t('Подробно опишите суть предложения, цели и ожидаемый результат.')" />
                  </label>
                  <ckeditor
                    :editor="editor"
                    v-model="offerContent"
                    :config="editorConfig"
                  ></ckeditor>
                </div>
                <div class="form-group form-files">
                  <div class="row">
                    <div class="col-sm-2">
                      <label>
                        {{ $t("Файлы") }}
                        <fieldInfo :title="$t('При необходимости прикрепите файлы, относящиеся к вашему предложению.')" />
                      </label>
                    </div>
                    <div class="col-sm-10">
                      <div class="files">
                        <div class="file-item">
                          <i
                            aria-hidden="true"
                            class="v-icon notranslate v-icon--link mdi mdi-paperclip"
                          ></i>
                          <v-file-input
                            :label="$t('Выберите файлы')"
                            :aria-label="$t('Выберите файлы')"
                            v-model="uploadedFile"
                            class="v-input__control black-placeholder"
                          >
                          </v-file-input>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Поле Email -->
                <div
                  class="form-group"
                  :class="{
                    invalid: $v.offerEmail.$dirty && ($v.offerEmail.$invalid)
                  }"
                >
                  <div class="row align-end">
                    <div class="col-sm-2">
                      <label for="offerEmail">
                        Укажите ваш Email
                        <span class="asterix">*</span>
                      </label>
                    </div>
                    <div class="col-sm-3">
                      <v-text-field
                        id="offerEmail"
                        v-model="offerEmail"
                        :aria-label="$t('Укажите ваш Email')"
                        :aria-invalid="$v.offerEmail.$dirty && ($v.offerEmail.$invalid) ? 'true' : 'false'"
                        aria-describedby="offer-email-required offer-email-format"
                        outlined
                        rounded
                        dense
                        placeholder="example@mail.com"
                      ></v-text-field>
                      <small id="offer-email-required" v-if="$v.offerEmail.$dirty && !$v.offerEmail.required" class="helper-text red--text">
                        {{ $t('Поле Email обязательно для заполнения') }}
                      </small>
                      <small id="offer-email-format" v-else-if="$v.offerEmail.$dirty && !$v.offerEmail.email" class="helper-text red--text">
                        {{ $t('Введите корректный Email') }}
                      </small>
                    </div>
                  </div>
                </div>
                <div class="form-group form-action">
                  <button
                    class="btn btn-default white"
                    type="button"
                    @click="onCancel"
                  >
                    {{ $t("Отмена") }}
                  </button>
                  <button class="btn btn-default blue" type="submit" value="1">
                    {{ $t("Опубликовать") }}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Search from '@/components/Search'
import fieldInfo from '@/components/app/fieldInfo'
import Offer from '@/model/offer'
import { required, email} from 'vuelidate/lib/validators'
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor'
import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials'
import BoldPlugin from '@ckeditor/ckeditor5-basic-styles/src/bold'
import ItalicPlugin from '@ckeditor/ckeditor5-basic-styles/src/italic'
import LinkPlugin from '@ckeditor/ckeditor5-link/src/link'
import ParagraphPlugin from '@ckeditor/ckeditor5-paragraph/src/paragraph'
import HeadingPlugin from '@ckeditor/ckeditor5-heading/src/heading'
import HorizontalLine from '@ckeditor/ckeditor5-horizontal-line/src/horizontalline'
import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment'
import Table from '@ckeditor/ckeditor5-table/src/table'
import TableToolbar from '@ckeditor/ckeditor5-table/src/tabletoolbar'
import { mapMutations } from 'vuex'
import {Trans} from "@/plugins/Translation"
export default {
  components: {
    Search,
    fieldInfo
  },
  data() {
    return {
      uploadedFile: null,
      offerTitle: '',
      offerContent: '',
      offerCategory: null,
      offerType: null,
      offerDeveloper: [],
      offerEmail: '',
      refCategory: [],
      refDeveloper: [],
      refOfferType: [],
      breadcrumbs: [],
      editor: ClassicEditor,
      editorConfig: {
        plugins: [
          EssentialsPlugin,
          BoldPlugin,
          ItalicPlugin,
          LinkPlugin,
          ParagraphPlugin,
          HeadingPlugin,
          HorizontalLine,
          Alignment,
          Table,
          TableToolbar
        ],

        toolbar: [
          'heading',
          '|',
          'bold',
          'italic',
          'link',
          'alignment',
          '|',
          'horizontalLine',
          '|',
          'undo',
          'redo',
          '|',
          'insertTable'
        ],
        table: {
          contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
        },
        heading: {
          options: [
            {
              model: 'paragraph',
              title: 'Paragraph',
              class: 'ck-heading_paragraph'
            },
            {
              model: 'heading1',
              view: 'h1',
              title: 'Heading 1',
              class: 'ck-heading_heading1'
            },
            {
              model: 'heading2',
              view: 'h2',
              title: 'Heading 2',
              class: 'ck-heading_heading2'
            },
            {
              model: 'heading3',
              view: 'h3',
              title: 'Heading 3',
              class: 'ck-heading_heading3'
            }
          ]
        }
      }
    }
  },
  computed: {
    user() {
      return this.$store.state.getUser.currentUser
    }
  },
  validations: {
    offerTitle: { required },
    offerType: { required },
    offerContent: { required },
    offerEmail: { required, email }
  },
  async created() {
    const { parentMenu, refCategory, refOfferType, refDeveloper } = await this.$store.dispatch(
      'fetchOfferData'
    )
    this.breadcrumbs = [{ text: this.$i18n.t('Главная'), disabled: false, href: '/' }]
    this.refCategory = refCategory
    this.refOfferType = refOfferType
    this.refDeveloper = refDeveloper
    this.breadcrumbs = [
      { text: this.$i18n.t('Главная'), disabled: false, href: Trans.currentLocaleUrl + '/' },
      {
        text: parentMenu.transTitle,
        disabled: false,
        href: Trans.currentLocaleUrl + '/offer'
      },
      {
        text: this.$i18n.t('Разместить предложение'),
        disabled: true,
      }
    ]

    if (this.user) {
      this.offerEmail = this.user.email;
    }

    this.scrollToTop();
  },
  methods: {
    ...mapMutations(['setLoading']),
    createOffer() {
      if (this.$v.$invalid) {
        this.$v.$touch()
        this.$nextTick(() => {
          this.scrollToFirstError()
        })
        return
      }
      let f = this.$refs.form
      let fd = new FormData(f)
      console.log(this.uploadedFile);
      fd.append('offer[email]', this.offerEmail);
      fd.append('offer[title]', this.offerTitle)
      fd.append('offer[content]', this.offerContent)
      fd.append('offer[type]', this.offerType)
      if (this.offerCategory) fd.append('offer[category]', this.offerCategory)
      if (this.offerDeveloper) {
        this.offerDeveloper.forEach((value, index) => {
          fd.append(`offer[developer][${index}]`, value)
        })
      }
      fd.append('offer[file]', this.uploadedFile)

      console.log(this.uploadedFile);

      this.setLoading(true)
      Offer.createOffer(fd)
        .then((response) => {
          this.$router.push(Trans.i18nRoute({
            name: 'offer-view',
            params: {
              id: response.data.offer
            }
          }))
          this.setLoading(false)
        })
        .catch((error) => {
          this.$router.push(Trans.i18nRoute({
            name: 'error',
            params: {
              status: error.response.status
            }
          }))
          this.setLoading(false)
        })
    },
    scrollToFirstError() {
      const domRect = document.querySelector('.invalid').getBoundingClientRect()
      window.scrollTo(
        domRect.left +
          (document.body.scrollLeft || document.documentElement.scrollLeft),
        domRect.top +
          (document.body.scrollTop || document.documentElement.scrollTop) -
          90
      )
    },
    onCancel() {
      this.$router.push(Trans.i18nRoute({
        name: 'offer-list'
      }))
    },
    scrollToTop() {
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style lang="scss" scoped>
.col-sm-2,
.col-sm-3,
.col-sm-9,
.col-sm-10 {
  padding-top: 0px;
  padding-bottom: 0px;
}
.form-files {
  label {
    min-width: auto;
  }
}
.files {
  .file-item {
    display: flex;
    i {
      position: relative;
      top: -4px;
    }
    .v-input {
      max-width: 240px;
      margin: 0;
      padding: 0;
      white-space: nowrap;
    }
  }
}

::v-deep(.black-placeholder .v-label) {
  color: #000 !important;
  text-decoration: underline;
  cursor: pointer;
}

::v-deep(.black-placeholder input::placeholder) {
  color: #000 !important;
  opacity: 1 !important;
}
</style>
